/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Position } from './layout.types';
import { Dimension } from '../UNSAFE_visTypes/common';
/**
 * Clones the given dimension.
 */
export function cloneDimension(dims: Dimension) {
  return {
    x: dims.x,
    y: dims.y,
    height: dims.height,
    width: dims.width
  };
}

export function getSectionDims(
  availSpace: Dimension,
  position: Position,
  width: number,
  height: number
) {
  if (position === 'left') {
    return {
      x: availSpace.x,
      width: height,
      height: width,
      y: availSpace.y
    };
  } else if (position === 'top') {
    return {
      x: availSpace.x,
      width: width,
      height: height,
      y: availSpace.y
    };
  } else if (position === 'bottom') {
    return {
      x: availSpace.x,
      y: availSpace.y + availSpace.height - height,
      height: height,
      width: width
    };
  } else {
    return {
      x: availSpace.x + availSpace.width - height,
      y: availSpace.y,
      width: height,
      height: width
    };
  }
}
